import * as types from '../mutation-types'

// state
export const state = {
    current_requests: {}
};

// getters
export const getters = {
    current_requests: state => state.current_requests,
    isset_current_requests_issued: (state, getters) => {
        let count = 0;
        for (let key in getters.current_requests) {
            if (state.current_requests[key].status === "oformlen") count++;
        }
        return !!count;
    },
};

// mutations
export const mutations = {
    update(state, data) {
        let obj = _.cloneDeep(state.current_requests);
        obj[data.bank_id + "_" + data.credit_type] = data.request;
        state.current_requests = obj;
    },
    remove(state, data) {
        let obj = _.cloneDeep(state.current_requests);
        delete obj[data.bank_id + "_" + data.credit_type];
        state.current_requests = obj;
    },
    clear(state) {
        state.current_requests = {};
    }
};

// actions
export const actions = {
    update(context, data) {
        context.commit('update', data);
    },
    remove(context, data) {
        context.commit('remove', data);
    },
    clear(context) {
        context.commit('clear');
    },
};
